<template>
  <div class="content" v-loading="loading">
    <el-form class="form-box" :model="form" :rules="rules">
      <el-button class="btn" type="primary" @click="onSaveSetting"
        >保存设置</el-button
      >
      <div class="title-line">
        订单维权关闭成功短信内容设置
        <span class="tip">变量值不支持修改，文案内容可编辑</span>
      </div>
      <el-form-item prop="orders_refund_close">
        <el-input
          class="input"
          v-model="form.orders_refund_close.content"
          type="textarea"
          :rows="3"
        ></el-input>
        <el-checkbox
          label="启用改消息通知"
          v-model="form.orders_refund_close.is_send"
        ></el-checkbox>
      </el-form-item>
      <div class="title-line">
        商品兑换成功短信内容设置<span class="tip"
          >变量值不支持修改，文案内容可编辑</span
        >
      </div>
      <el-form-item prop="pay_products">
        <el-input
          class="input"
          v-model="form.pay_products.content"
          type="textarea"
          :rows="3"
        ></el-input>
        <el-checkbox
          label="启用改消息通知"
          v-model="form.pay_products.is_send"
        ></el-checkbox>
      </el-form-item>
      <div class="title-line">
        商品发货成功通知<span class="tip"
          >变量值不支持修改，文案内容可编辑</span
        >
      </div>
      <el-form-item prop="send_products_success">
        <el-input
          class="input"
          v-model="form.send_products_success.content"
          type="textarea"
          :rows="3"
        ></el-input>
        <el-checkbox
          label="启用改消息通知"
          v-model="form.send_products_success.is_send"
        ></el-checkbox>
      </el-form-item>
      <div class="title-line">
        红包入账通知<span class="tip">变量值不支持修改，文案内容可编辑</span>
      </div>
      <el-form-item prop="recharge_red_picket">
        <el-input
          class="input"
          v-model="form.recharge_red_picket.content"
          type="textarea"
          :rows="3"
        ></el-input>
        <el-checkbox
          label="启用改消息通知"
          v-model="form.recharge_red_picket.is_send"
        ></el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getNoticeData, saveNoticeData } from '@/api/redpacket'
export default {
  data() {
    return {
      loading: false,
      rules: {
        orders_refund_close: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        exchangeText: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        send_products_success: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        recharge_red_picket: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      form: {
        orders_refund_close: {
          is_send: false,
          content: ''
        },
        pay_products: {
          is_send: false,
          content: ''
        },
        send_products_success: {
          is_send: false,
          content: ''
        },
        recharge_red_picket: {
          is_send: false,
          content: ''
        }
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getNoticeData().then(res => {
        if (res.code === 10000) {
          if (res.data) {
            if (res.data.orders_refund_close) {
              this.form.orders_refund_close.is_send =
                res.data.orders_refund_close.is_send || false
              this.form.orders_refund_close.content =
                res.data.orders_refund_close.content || ''
            }
            if (res.data.pay_products) {
              this.form.pay_products.is_send =
                res.data.pay_products.is_send || false
              this.form.pay_products.content =
                res.data.pay_products.content || ''
            }
            if (res.data.send_products_success) {
              this.form.send_products_success.is_send =
                res.data.send_products_success.is_send || false
              this.form.send_products_success.content =
                res.data.send_products_success.content || ''
            }
            if (res.data.recharge_red_picket) {
              this.form.recharge_red_picket.is_send =
                res.data.recharge_red_picket.is_send || false
              this.form.recharge_red_picket.content =
                res.data.recharge_red_picket.content || ''
            }
          }
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    onSaveSetting() {
      this.loading = true
      saveNoticeData({
        orders_refund_close: JSON.stringify(this.form.orders_refund_close),
        pay_products: JSON.stringify(this.form.pay_products),
        send_products_success: JSON.stringify(this.form.send_products_success),
        recharge_red_picket: JSON.stringify(this.form.recharge_red_picket)
      }).then(res => {
        if (res.code == 10000) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .form-box {
    background-color: #e0e0e0;
    padding: 20px;
    position: relative;
    .btn {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .title-line {
      margin-bottom: 10px;
      .tip {
        background-color: orange;
        margin-left: 12px;
        color: #fff;
      }
    }

    .input {
      width: 600px;
      margin-right: 20px;
    }
  }
}
</style>
